import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField
} from '@material-ui/core';
import useStyles from './style';
import CircularProgress from '@material-ui/core/CircularProgress';
import { GraphQL, gql } from 'core';
import { isEmpty } from 'lodash';

type Props = {
  isOpen: boolean;
  handleClose: () => void;
  reportId?: string;
};

const EDIT_REPORTED_ERROR = gql`
  mutation editReportedFundamentalError($id: Int, $description: String) {
    editReportFundamentalError(id: $id, description: $description) {
      success
      error
    }
  }
`;

export const ReportFundamentalErrorModal = ({ isOpen, handleClose, reportId }: Props) => {
  const [description, setDescription] = useState<string | null>();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const classes = useStyles();

  useEffect(() => {
    if (isOpen) {
      setDescription(null);
      setIsSubmitting(false);
    }
  }, [isOpen]);

  const onSubmitComment = async () => {
    setIsSubmitting(true);
    try {
      await GraphQL.mutate({
        mutation: EDIT_REPORTED_ERROR,
        variables: { id: reportId, description }
      });
    } catch (e) {}
    setIsSubmitting(false);
    handleClose();
  };

  return (
    <Dialog open={isOpen} onClose={handleClose}>
      <DialogTitle>Report Error</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Thank you for reporting error, it will be resolved soon, if you have further comments
          please add it to the box below
        </DialogContentText>
        <TextField
          autoFocus
          variant="outlined"
          className={classes.field}
          label={'Comment'}
          inputProps={{ className: classes.input }}
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          multiline={true}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color={'primary'}>
          Cancel
        </Button>
        <Button
          onClick={onSubmitComment}
          variant={'contained'}
          color={'primary'}
          disabled={isEmpty(description) || isSubmitting}
        >
          Submit Comment
          {isSubmitting && (
            <CircularProgress size={24} classes={{ colorPrimary: classes.progressBar }} />
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
